import React from "react";
import PropTypes from "prop-types";
import CircularProgressbar from "react-circular-progressbar";
import AttributeToOpen from "components/RestaurantDetails/AttributeToOpen.js";

export default function Score(props) {
  const restaurant = props.restaurant;

  const getCircleScore = type => {
    const restaurant = props.restaurant;

    let percentage;
    let score;
    if (type === "price") {
      percentage = 100;
      score =
        restaurant.price &&
        restaurant.price.value &&
        !isNaN(restaurant.price.value)
          ? `${restaurant.price.value.toFixed(0)}€`
          : "-";
    } else if (type === "location") {
      percentage = restaurant.scorePlace * 10;
      score = restaurant.scorePlace ? restaurant.scorePlace.toFixed(1) : "-";
    } else if (type === "food") {
      percentage = restaurant.scoreFood * 10;
      score = restaurant.scoreFood ? restaurant.scoreFood.toFixed(1) : "-";
    } else if (type === "service") {
      percentage = restaurant.scoreService * 10;
      score = restaurant.scoreService
        ? restaurant.scoreService.toFixed(1)
        : "-";
    }
    if (score >= 10) {
      score = "10";
    }
    return (
      <div className="RestaurantInfo-rating">
        <CircularProgressbar
          percentage={percentage}
          textForPercentage={() => score}
          initialAnimation
          className="RestaurantInfo-rating"
          styles={{
            text: {
              fontFamily: '"Archivo Black"',
              fontSize: "30px",
              fill: "#e8312b"
            },
            stroke: {
              backgroundImage: "linear-gradient(317deg, #96bb65, #28a159)"
            }
          }}
        />
      </div>
    );
  };

  let scoreOverall = "-";

  if (!isNaN(restaurant.scoreOverall)) {
    if (restaurant.scoreOverall > 9.95) {
      scoreOverall = "10";
    } else if (!restaurant.scoreOverall || restaurant.scoreOverall <= 1) {
      if (
        restaurant.facebook &&
        restaurant.facebook.overall_star_rating &&
        Number(restaurant.facebook.overall_star_rating) > 0
      ) {
        if (Number(restaurant.facebook.overall_star_rating) >= 5) {
          scoreOverall = "10";
        } else {
          scoreOverall = (
            Number(restaurant.facebook.overall_star_rating) * 2
          ).toFixed(1);
        }
      } else {
        scoreOverall = "-";
      }
    } else {
      scoreOverall = restaurant.scoreOverall.toFixed(1);
    }
  }
  let checkInNumber = `- check-in`;
  if (restaurant.checkInNumber) {
    checkInNumber = `${restaurant.checkInNumber} check-in`;
  }

  return (
    <>
      <div className="restaurant-head-main-info">
        <div>
          <div className="RestaurantInfo-rating-container aggregateRating">
            <div className="RestaurantInfo-rating-overall">
              <span>Voto complessivo </span>
              <span style={{ fontFamily: '"Archivo Black"' }}>
                {scoreOverall}
              </span>
            </div>
            {/* <div className="RestaurantInfo-review-counter aggregateRating">
              {restaurant.facebook &&
              restaurant.facebook.rating_count &&
              Number(restaurant.facebook.rating_count) > 0 ? (
                <div>
                  <div className="RestaurantInfo-facebook-reviews-counter">
                    {restaurant.facebook.rating_count}
                    <span style={{ fontSize: "12px" }}>{" esperienze"}</span>
                  </div>
                  {restaurant.checkInNumber && restaurant.checkInNumber > 0 ? (
                    <div>
                      <i
                        className="
                            icon icon-pugnetto-24 RestaurantInfo-icon-certified-experiences
                            "
                      />
                      <div className="RestaurantInfo-counter-certified-experiences">
                        {restaurant.checkInNumber} Check-in
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                checkInNumber
              )}
            </div> */}
          </div>
        </div>
        <div>
          <div className="RestaurantInfo-rating-circles-container">
            {restaurant.scoreFood || restaurant.scoreFood === 0 ? (
              <div
                className="RestaurantInfo-rating-container"
                style={{ marginRight: "30px" }}
              >
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  menu
                </div>
                {getCircleScore("food")}
              </div>
            ) : null}
            {restaurant.scorePlace || restaurant.scorePlace === 0 ? (
              <div
                className="RestaurantInfo-rating-container"
                style={{ marginRight: "30px" }}
              >
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  location
                </div>
                {getCircleScore("location")}
              </div>
            ) : null}
            {restaurant.scoreService || restaurant.scoreService === 0 ? (
              <div
                className="RestaurantInfo-rating-container"
                style={{ marginRight: "30px" }}
              >
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  servizio
                </div>
                {getCircleScore("service")}
              </div>
            ) : null}
            {restaurant.scoreService || restaurant.scoreService === 0 ? (
              <div className="RestaurantInfo-rating-container">
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  prezzo
                </div>
                <div className="RestaurantInfo-rating">
                  {getCircleScore("price")}
                </div>
              </div>
            ) : null}
          </div>
          <div className="restaurant-other-information">
            {restaurant.priceMinimum &&
            !isNaN(restaurant.priceMinimum) &&
            restaurant.priceMinimum > 0 &&
            restaurant.priceMaximum &&
            !isNaN(restaurant.priceMaximum) &&
            restaurant.priceMaximum > 0 ? (
              <p
                className="RestaurantInfo-crew"
                style={{ float: "left", marginTop: "20px" }}
              >
                <span className="RestaurantInfo-label-description">
                  Range di prezzo
                </span>{" "}
                {restaurant.priceMinimum.toFixed(2)}€ -{" "}
                {restaurant.priceMaximum.toFixed(2)}€
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

Score.propTypes = {
  restaurant: PropTypes.object.isRequired
};
